export default __webpack_public_path__ + "static/media/hop2.8c430760.jpg";